export const MISC_ALERT = 'MISC_ALERT'

// MISC
export const miscAlert = (alert) => ({
  type: MISC_ALERT,
  alert
})
